export const SELECT_POST = 'SELECT_POST';
export const TOGGLE_SUBSCRIPTION = 'TOGGLE_SUBSCRIPTION';
export const TOGGLE_LIKE = 'TOGGLE_LIKE';
export const TOGGLE_BOOKMARK = 'TOGGLE_BOOKMARK';
export const CREATE_COMMENT = 'CREATE_COMMENT';
export const CREATE_RECOMMENT = 'CREATE_RECOMMENT';
export const TOGGLE_LIKE_COMMENT = 'TOGGLE_LIKE_COMMENT';
export const TOGGLE_LIKE_RECOMMENT = 'TOGGLE_LIKE_RECOMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const DELETE_RECOMMENT = 'DELETE_RECOMMENT';

export const SELECT_COMMENTS = 'SELECT_COMMENTS';
export const SELECT_RECOMMENTS = 'SELECT_RECOMMENTS';
